// A Studio run's statuses (studio.runs.status; docs/studio-workbench.md, "The run model"). Pure, so the
// route tree can parse the Runs page's `?status=` without loading the data layer.

export const RUN_STATUSES = [
  'awaiting_approval',
  'queued',
  'running',
  'review',
  'failed',
  'cancelled',
  'planning',
  'done',
] as const;

export type RunStatus = (typeof RUN_STATUSES)[number];

export function isRunStatus(v: unknown): v is RunStatus {
  return typeof v === 'string' && (RUN_STATUSES as readonly string[]).includes(v);
}
